import styled from "styled-components";

export const Button = styled.button`
  outline: none;
  cursor: pointer;
  transition-duration: 0.1s;
  border: none;
  font-weight: 700;
  background-color: #b80016;
  color: white;
  margin: 0.5em;
  width: 10em;
  height: 2.5em;
  border-radius: 16px;
  &:disabled {
    cursor: default;
    background-color: #9e0000;
    color: #c7c7c7;
  }
  &:hover:enabled {
    background-color: #ff001f;
    box-shadow: 0 2px 3px #999;
  }
  &:active:enabled {
    box-shadow: 0 0px 2px #666;
    background-color: #ff001f;
    transform: translateY(1px);
  }

  @media only screen and (max-width: 500px) {
    width: 8.5em;
    height: 2.25em;
    font-size: 1em;
  }

  @media only screen and (max-width: 375px) {
    width: 8.25em;
    height: 2.125em;
    font-size: 0.9em;
  }
`;

export const Text = styled.h2`
  font-size: 1.25em;
  font-weight: 700;
  text-align: center;
  color: white;

  @media only screen and (max-width: 500px) {
    font-size: 1.125em;
  }

  @media only screen and (max-width: 375px) {
    font-size: 1em;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-flow: column wrap;
  min-width: 75%;
  min-height: 80vh;
  max-height: 80vh;
  position: relative;
  padding-top: 1em;
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ChatContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  min-width: 70%;
  min-height: 80vh;
  max-height: 80vh;
  position: relative;
  padding-top: 1em;
`;

export const Logo = styled.img`
  height: 100px;
`;
